import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardActions, CardContent, CardHeader, Typography, } from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useContext } from "react";
import { SecureMessageContext } from "./SecureMessagingContext";
import dayjs from "dayjs";
const SHORT_DESCRIPTION_LENGTH = 80;
const MessageOverviewCard = (props) => {
    const selectedMessageContext = useContext(SecureMessageContext);
    function handleSelectMessage() {
        props.handleSelectMessage(props.message);
    }
    if (!props.message.ToDoItem.Messages ||
        props.message.ToDoItem.Messages.length === 0) {
        return _jsx(_Fragment, {});
    }
    const lastDate = props.message.ToDoItem.Messages[props.message.ToDoItem.Messages.length - 1].CreatedOn;
    return (_jsxs(Card, { className: `messageItem ${!props.message.IsRead ? "unreadMessage" : ""} ${selectedMessageContext?.SelectedMessage?.Id === props.message.Id
            ? "selectedMessage"
            : ""}`, elevation: 0, onClick: handleSelectMessage, sx: {
            "&:hover": {
                cursor: "pointer",
            },
        }, children: [_jsx(CardHeader, { title: _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h4", className: "messageTitle", children: props.message.Subject }), _jsx(Typography, { variant: "caption", className: "messageDate", children: new Date(lastDate).toDateString() ===
                                new Date().toDateString() ? (new Date(lastDate).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                            })) : (_jsx(_Fragment, { children: dayjs(lastDate).format("DD/MM/YY") })) })] }) }), _jsx(CardContent, { children: _jsxs(Typography, { variant: "body2", color: "text.secondary", children: [props.message.ToDoItem.Messages[props.message.ToDoItem.Messages.length - 1].Text.substring(0, SHORT_DESCRIPTION_LENGTH).trimEnd(), props.message.ToDoItem.Messages[props.message.ToDoItem.Messages.length - 1].Text.length > SHORT_DESCRIPTION_LENGTH && "..."] }) }), _jsxs(CardActions, { children: [props.message.ToDoItem.AccountNumber && (_jsxs("span", { children: [_jsx(LocalOfferIcon, {}), " ", props.message.ToDoItem.AccountNumber, " "] })), _jsxs("span", { children: [_jsx(ForumIcon, {}), " ", props.message.ToDoItem.Messages?.length] })] })] }));
};
export default MessageOverviewCard;
